import { createApi } from '@reduxjs/toolkit/query/react';
import { PURCHASE_BASE_URL } from 'shared/api/api';
import { createBaseQuery } from 'shared/api/rtk-query';
import { PurchaseDto, PurchaseStatusUpdateResultDto, UpdatePurchaseStatusDto, UpdatePurchaseDto } from '@sr/dto';

export const purchaseApi = createApi({
  reducerPath: 'purchases',
  baseQuery: createBaseQuery(PURCHASE_BASE_URL),
  endpoints: (builder) => ({
    getPurchase: builder.query<PurchaseDto, number>({
      query: (id) => ({
        url: `${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, query) => [{ type: 'purchases', id: query }]
    }),
    updatePurchase: builder.mutation<PurchaseDto, UpdatePurchaseDto>({
      query: (dto) => ({
        url: 'update',
        method: 'POST',
        body: dto
      }),
      invalidatesTags: (res, error, query) => [{ type: 'purchases', id: query.id }]
    }),
    updatePurchaseStatus: builder.mutation<PurchaseStatusUpdateResultDto, UpdatePurchaseStatusDto>({
      query: ({ ...dto }) => ({
        url: '/status',
        body: dto,
        method: 'PUT'
      }),
      invalidatesTags: (res, error, query) => [{ type: 'purchases', id: query.id }]
    })
  }),
  tagTypes: ['purchases']
});
